import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ReferenceNavigasi } from '../../../models/master-user/reference-navigasi.model';
import { ReferenceNavigasiApiService } from '../../api/master-user/reference-navigasi.api.service';
import { DataService } from '../data.service';

@Injectable({
  providedIn: 'root',
})
export class ReferenceNavigasiDataService implements DataService<ReferenceNavigasi> {
  constructor(private referenceNavigasiApiService: ReferenceNavigasiApiService) {}

  public getAll(): Observable<ReferenceNavigasi[]> {
    return this.referenceNavigasiApiService.getAll();
  }
  public getNavigasi(params?: any): Observable<ReferenceNavigasi[]> {
    return this.referenceNavigasiApiService.getNavigasi(params);
  }
  public getReferenceNavigasiAll(): Observable<ReferenceNavigasi[]> {
    return this.referenceNavigasiApiService.getReferenceNavigasiAll();
  }
}
